document.addEventListener('DOMContentLoaded', function () {
  function slug(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isVisible(el) {
    return !!(el && el.offsetParent !== null && window.getComputedStyle(el).display !== 'none');
  }

  function getThumbBase() {
    return document.querySelector('.customoptions--wrapper')?.getAttribute('data-thumb-base') || '';
  }

  function getPreviewVersion() {
    const preview = document.querySelector('[data-bundle-preview]');
    return preview?.getAttribute('data-preview-version') || '';
  }

  function updateWrapThumb(wrap) {
    const box = wrap.querySelector('.bundle-row-thumb');
    const img = box?.querySelector('img');

    if (!box || !img) return;

    if (!isVisible(wrap)) {
      img.hidden = true;
      img.removeAttribute('src');
      return;
    }

    const type = box.getAttribute('data-thumb-type');
    const rawColor = wrap.querySelector('.color_title .color')?.innerText || '';
    const color = slug(rawColor.split('/')[0].trim());

    if (!type || !color) {
      img.hidden = true;
      img.removeAttribute('src');
      return;
    }

    const base = getThumbBase();
    const version = getPreviewVersion();
    const filename = `thumb-${type}-${color}.png`;
    const src = version ? `${base}${filename}?v=${version}` : `${base}${filename}`;

    img.onload = function () {
      img.hidden = false;
    };

    img.onerror = function () {
      img.hidden = true;
      img.removeAttribute('src');
    };

    img.src = src;
  }

  function updateAllThumbs() {
    document.querySelectorAll('.customoptions--wrapper .customoptions--wrap').forEach(updateWrapThumb);
  }

  let timer = null;
  function queueUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateAllThumbs, 60);
  }

  setTimeout(updateAllThumbs, 150);

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.customoptions--wrapper .options ul li') ||
      e.target.closest('.customoptions--wrapper input[type="checkbox"]') ||
      e.target.closest('.variant-picker-list-Size')
    ) {
      queueUpdate();
    }
  });

  const root = document.querySelector('.customoptions--wrapper');
  if (root) {
    const observer = new MutationObserver(queueUpdate);
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});